import React, { useState } from "react";
import { Button } from "antd";
import "./style.scss";
import { AddAppUsersForm } from "../AddAppUsers";

const ActionHeader = ({ onSubmitSuccess, onFieldSelected }: any) => {
   const [showAddEditForm, setShowAddEditForm] = useState(false);
   const handleShowAddEditForm = () => {
      setShowAddEditForm(true);
   };
   const handleAddEditFormCancelEvent = () => {
      setShowAddEditForm(false);
   };

   const handleAddEditFormSubmitEvent = () => {
      setShowAddEditForm(false);
   };

   return (
      <>
         <div className="action-header-wrapper">
            <Button type="primary" size="large" onClick={handleShowAddEditForm}>
               Add User
            </Button>
         </div>
         {showAddEditForm && (
            <AddAppUsersForm
               onSubmitSuccess={onSubmitSuccess}
               showForm={showAddEditForm}
               onSubmit={handleAddEditFormSubmitEvent}
               onCancel={handleAddEditFormCancelEvent}></AddAppUsersForm>
         )}
      </>
   );
};

export default ActionHeader;
